if (!customElements.get('accordion-header')) {
  class AccordionHeader extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll('.accordion-header__button');
      this.buttons.forEach(button => {
        button.addEventListener('click', this.onButtonClick.bind(this));
      });
    }

    onButtonClick(event) {
      const button = event.currentTarget;
      
      // Update active state
      this.buttons.forEach(btn => {
        btn.classList.remove('active');
        btn.setAttribute('aria-selected', 'false');
      });
      button.classList.add('active');
      button.setAttribute('aria-selected', 'true');

      const category = button.getAttribute('data-category');
      this.filterAccordions(category);
    }

    filterAccordions(category) {
      const accordionSections = document.querySelectorAll('.section-accordions');
      const normalizedCategory = category.trim().toLowerCase();

      accordionSections.forEach(section => {
        const accordionContent = section.querySelector('.accordions[data-category]');
        if (!accordionContent) return;

        const sectionCategory = accordionContent.getAttribute('data-category').trim().toLowerCase();
        
        if (normalizedCategory === 'all' || normalizedCategory === sectionCategory) {
          section.style.display = '';
          
          // Reset and trigger animation
          accordionContent.classList.remove('animation-init', 'animation-none');
          void accordionContent.offsetWidth; // trigger reflow
          accordionContent.classList.add('animation-init');
        } else {
          section.style.display = 'none';
        }
      });
    }
  }

  customElements.define('accordion-header', AccordionHeader);
}
